import i18n from '../i18n';

export const sanitizeInputName = (name: string, isGroup = false) => {
  let sanitizedName = name;
  const regex = isGroup ? /[^a-zA-Z0-9\s]/g : /[^a-zA-Z\s]/g;
  sanitizedName = sanitizedName.replace(regex, '');
  sanitizedName = sanitizedName.replace(/\s+/g, ' '); // Remove extra spaces
  sanitizedName = sanitizedName.replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
  return sanitizedName;
};

export const isValidEmail = (emailInput: string) => /\S+@\S+\.\S+/.test(emailInput);

export const getInitials = (_firstName: string, _lastName?: string): string => {
  if (!_firstName && !_lastName) {
    return 'UN';
  }
  const firstName = _firstName.trim();
  const lastName = _lastName?.trim();
  if (firstName?.length && lastName?.length) {
    return `${firstName[0].toUpperCase()}${lastName[0].toUpperCase()}`;
  }
  if (firstName?.length) {
    // firstname only
    const [firstNamePart1, ...firstNameRest] = firstName.split(' ');
    const firstNamePart2 = firstNameRest.find((i) => i.length);
    if (firstNamePart2?.length) {
      return getInitials(firstNamePart1, firstNamePart2);
    }

    if (firstNamePart1.length > 1) {
      return `${firstNamePart1[0]}${firstNamePart1[1]}`.toUpperCase();
    }
    // if one letter in firstname, return first letter twice
    return `${firstNamePart1[0]}${firstNamePart1[0]}`.toUpperCase();
  }

  if (lastName?.length) {
    // lastname only
    return getInitials(lastName);
  }
  // fallback
  return 'UN';
};

export const isValidPhoneNumber = (number: string) => /^[0-9-().\s+]+$/.test(number);

export const getGenderFromPronoun = (pronoun?: string): string => {
  let gender: string;

  if (pronoun === 'He') {
    gender = 'male';
  } else if (pronoun === 'She') {
    gender = 'female';
  } else {
    gender = 'unknown';
  }

  return gender;
};

export const passwordRequirements = (password: string, confirmPassword: string) => [
  {
    text: i18n.t('changePassword.passwordValidations.passwordLowercase'),
    isValid: () => /[a-z]/.test(password),
  },
  {
    text: i18n.t('changePassword.passwordValidations.passwordUppercase'),
    isValid: () => /[A-Z]/.test(password),
  },
  {
    text: i18n.t('changePassword.passwordValidations.passwordNumber'),
    isValid: () => /\d/.test(password),
  },
  {
    text: i18n.t('changePassword.passwordValidations.passwordSpecialCharacter'),
    isValid: () => /\W/.test(password),
  },
  {
    text: i18n.t('changePassword.passwordValidations.miniumPasswordLength'),
    isValid: () => password.length >= 8,
    isLoginRequirement: true,
  },
  {
    text: i18n.t('changePassword.passwordValidations.passwordMatch'),
    isValid: () =>
      password.length > 0 && confirmPassword.length > 0 && password === confirmPassword,
  },
];
